import { TFunction } from 'i18next';
import * as yup from 'yup';

// Provides a re-usable schema for site postcode form input/validation
export const makePostcodeFormSchema = (t: TFunction) => ({
  postCode: yup.string().label(t('Common.zipcode')).required().min(4).max(7),
});
